import { render, staticRenderFns } from "./ProfileSegment.vue?vue&type=template&id=0efa7a12&"
import script from "./ProfileSegment.vue?vue&type=script&lang=js&"
export * from "./ProfileSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports